export const appSettings = {
  clientId: process.env.VUE_APP_CLIENT_ID || "", // Client API ID
  clientSecret: process.env.VUE_APP_CLIENT_SECRET || "", // Client API Secret
  apiToken: process.env.VUE_APP_API_TOKEN || "", // Personal or Access Token
  teamId: process.env.VUE_APP_TEAM_ID || "",
  spaceId: process.env.VUE_APP_SPACE_ID || "",
  implementationId: process.env.VUE_APP_LIST_IMPLEMENTATION || "",
  ideationId: process.env.VUE_APP_LIST_IDEATION || "",
  messageId: process.env.VUE_APP_LIST_MESSAGE || "",
  moduleRequestListId: process.env.VUE_APP_MODULE_REQUEST_LIST_ID || " ",
  corsProxyUrl: process.env.VUE_APP_CORS_PROXY_URL, // URL of CORS Prfir
  hideTeams: false, // Hide Teams View from Menu
  hideProgressColumn: false, // Hide 'Progress' columns in views
  onlyFeatures: false, // Compact View showing only Features View (As Modules)
  goalsFolders: ["Status.vue"]
};
